<template>
  <div class="repairPage-container selfService-container">
    <div class="selfService-btns">
      <el-button
        type="primary"
        size="default"
        @click="$router.push({ name: 'RepairReq' })"
        >创建新寄修单</el-button
      >
      <el-button
        type="primary"
        size="default"
        @click="$router.push({ name: 'RepairUpdate' })"
        >更新寄修快递信息</el-button
      >
      <el-button
        type="primary"
        size="default"
        @click="$router.push({ name: 'RepairTrace' })"
        >查看进度</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.selfService-container {
  background: #fff;
  .selfService-btns {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
